export const whiteLabels = {
  anyword: 'anyword',
  teads: 'teads',
};
